module.exports = __webpack_public_path__ + "img/screen.04e2b843.png";